import {PackageButtonProps} from "../models/PropsInterface";


const PackageButton = (props: PackageButtonProps) => {

    const padding: { [key: string]: string } = {
        'left':props.language === 'en'?'package_button__left_most_package': 'package_button__right_most_package',
        'mid': '',
        'right':props.language === 'en'?'package_button__right_most_package': 'package_button__left_most_package',
    }
    // const isMembership = props.unit.service.includes('membership')
    const isMembership = false

    return (
        props.unit ?
            <div dir={props.language === 'en' ? 'ltr' : 'rtl'}
                 className={`services-package__col ${props.selectedName === props.name ? 'package_button__selected_package' : ''} package_button__package_item ${padding[props.padding]} package_button__centered `}>
                <button onClick={() => props.onClick(props.name)}
                        className={`content package_button__package_button package_button__content services-package__m-0 services-package__p-2`}>
                    <div className={`package_button__display_block`}>
                        {!isMembership && <img src={props.unit.icon} className={`package_button__package_item_icon`}/>}
                    </div>
                    <div>
                        <div className={`package_button__font_size_lg`}>{props.unit.appLabel}</div>
                    </div>
                </button>
            </div> : <div></div>
    )

}

export default PackageButton